var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-header"},[(!_vm.hideHeader)?_c('div',{staticClass:"head"},[_c('h1',[_vm._v("طباعة بواسطة : "+_vm._s(_vm.userCode))]),_c('h2',[_vm._v(_vm._s(_vm.date))])]):_vm._e(),_c('h3',[_vm._v("كشف عن "+_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }